webpackJsonp([8],{

/***/ "./src/app/data/screenshots/llanoseco/gallery.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gallery.4b83b587.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/llanoseco/news.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/news.afb942b5.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/llanoseco/pork.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pork.3a8cb784.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/llanoseco/shop.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shop.c50fa78a.jpg";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/work/llanoseco.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__("./node_modules/rebass/dist/index.js");
	
	var _Details = __webpack_require__("./src/Details/index.js");
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _link = __webpack_require__("./src/app/components/link/index.js");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _slider = __webpack_require__("./src/app/components/slider/index.js");
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _Lead = __webpack_require__("./src/Lead/index.js");
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _pork = __webpack_require__("./src/app/data/screenshots/llanoseco/pork.jpg");
	
	var _pork2 = _interopRequireDefault(_pork);
	
	var _shop = __webpack_require__("./src/app/data/screenshots/llanoseco/shop.jpg");
	
	var _shop2 = _interopRequireDefault(_shop);
	
	var _gallery = __webpack_require__("./src/app/data/screenshots/llanoseco/gallery.jpg");
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _news = __webpack_require__("./src/app/data/screenshots/llanoseco/news.jpg");
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = [{
	  src: _pork2.default,
	  alt: 'Llano Seco products description'
	}, {
	  src: _shop2.default,
	  alt: 'Llano Seco shop'
	}, {
	  src: _gallery2.default,
	  alt: 'Llano Seco gallery page'
	}, {
	  src: _news2.default,
	  alt: 'Llano Seco news page'
	}];
	
	var tags = ['Consumer Facing Website', 'Design', 'Javascript', 'HTML', 'CSS'];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Details2.default,
	      {
	        title: 'Llano Seco Rancho',
	        subtitle: 'Agriculture'
	      },
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\uD83D\uDC04', title: 'A family farm, that is older than your great grandfather' },
	        _react2.default.createElement(
	          _link2.default,
	          { target: '_blank', href: 'https://llanoseco.com/' },
	          'Llano Seco Rancho'
	        ),
	        ' has been raising pigs and cattle, and growing beans and ancient grains since 1861! They wanted to create a website to promote their great products, as well as increase awareness on how they preserve and grow the diversity of animal and plant existence on the Rancho.'
	      ),
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\u2764\uFE0F', title: 'A truly beautiful website' },
	        'We were excited that Llano Seco approached us to work on such an interesting project. The ranch has a long and interesting history, and we love to help well-established business getting of the ground on the web, with an awesome website. The final result is a truly beautiful and unique website, as evident by the screenshots below.'
	      ),
	      _react2.default.createElement(_Details2.default.Tags, { tags: tags }),
	      _react2.default.createElement(_slider2.default, { images: images }),
	      _react2.default.createElement(
	        _rebass.Box,
	        { mt: 5 },
	        _react2.default.createElement(_Lead2.default, null)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-work-llanoseco-js-db1c5249c8ac4e75d47c.js